import { Group, Stack, Text, Title } from "@mantine/core"
import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * A titled settings concept card. Groups stack several of these; each carries a
 * stable anchor id so settings search can scroll it into view and briefly ring
 * it. Purely presentational — the panel it wraps owns its own form state.
 */
export const SettingsSection = ({
  id,
  title,
  description,
  icon: Icon,
  highlighted = false,
  children,
}: IProps): React.JSX.Element => {
  return (
    <section id={id} className={`${classes.section} ${highlighted ? classes.highlighted : ""}`}>
      <Stack gap="xs" mb="md">
        <Group gap="xs" wrap="nowrap">
          {Icon && <Icon size={18} className={classes.icon} aria-hidden />}
          <Title order={4} className={classes.title}>
            {title}
          </Title>
        </Group>
        {description && (
          <Text size="sm" c="dimmed" className={classes.description}>
            {description}
          </Text>
        )}
      </Stack>
      {children}
    </section>
  )
}
